import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import PowerIcon from '@material-ui/icons/Power';
import PropTypes from 'prop-types';
import React from 'react';

const TotalCustomers = React.memo(({ rz, rztotalyearkw, year, ...rest }) => {
  //console.log('TotalCustomers is called')
  return (
  <Card {...rest}>
    <CardContent>
    <Grid
        container
        spacing={3}
        sx={{ justifyContent: 'space-between' }}
      >
        <Grid item>
        <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
            {rz}
          </Typography>
          
          <Typography
            color="#4a4a4a"
            variant="h3"
          >
            {new Intl.NumberFormat("de-DE").format(rztotalyearkw)} kWh
          </Typography>
          <Typography
            color="#4a4a4a"
            gutterBottom
            variant="h6"
          >
            GESAMTVERBRAUCH IT {year}
          </Typography>
        </Grid>
        <Grid item>
          <Avatar
            sx={{
              backgroundColor: '#1b66b3',
              color: '#fce531',
              height: 56,
              width: 56
            }}
          >
            <PowerIcon  />
          </Avatar>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
);
})

TotalCustomers.propTypes = {
  totalCustomers: PropTypes.any
};

export default TotalCustomers;
